const items = [
  { big: "€30", text: "Pilot-prijs (was €50) — componenten + werkend Simon Says-apparaat inbegrepen" },
  { big: "3u", text: "Per sessie — 2× langer dan CodeFever (1,5u), meer tijd voor echte skills" },
  { big: "8", text: "Kinderen max — tegenover 15-20 bij meeste alternatieven" },
  { big: "100%", text: "Hands-on hardware — echte Arduino + werkend apparaat mee naar huis" },
];

export function Proof() {
  return (
    <section className="bg-alt">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Waarom ons?</span>
          <h2>Vergelijken loont — cijfers op een rijtje</h2>
          <p>
            Drie uur workshop, kleine groep, tastbaar project. Hands-on hardware i.p.v.
            scherm-tunnelvisie.
          </p>
        </div>
        <div className="proof-grid">
          {items.map((i) => (
            <div className="proof-item" key={i.big}>
              <strong>{i.big}</strong>
              <span>{i.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
